export const CALENDAR_SESSION_ID = "CALENDAR_SESSION_ID";
export const TASK_SESSION_ID = "TASK_SESSION_ID";
export const CALENDAR_SPOTLIGHT_CLOSED = "CALENDAR_SPOTLIGHT_CLOSED";
export const PUBLIC_USER_EMAIL = "PUBLIC_USER_EMAIL";
